<template>
  <div class="d-flex" v-if="value != null">
    <div>
      <span class="font-weight-bold">
        {{ name }}
      </span>
    </div>
    <div class="ml-auto">
      <span>
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped></style>
